import { _get, _post } from "../../../../http";

// cuentas bancarias para los corporativos
export const getCuentasBancariasCorporativo = (corporativoId) => _get(`/cuentaBancaria/corporativos/${corporativoId}`);

export const postCuentasBancariasCorporativo = (corporativoId, body) =>
  _post(`/cuentaBancaria/corporativos/${corporativoId}`, body);
